// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3lnAH","col":"styles_col__1Np_n"};